import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  keyId: string;
};

export const deleteApiKey = async (scope: RequestScope, { keyId }: RequestParams, options: WriteRequestOptions): Promise<EndpointResponse<any>> => {
  try {
    const response = await scopedApi(scope).delete<EndpointResponse<any>>(`/organization/client/${keyId}`, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
